import { jwtDecode } from "jwt-decode";

export function decodeToken(
  token: string,
): { sub: string; expired?: boolean } | undefined {
  try {
    const decoded = jwtDecode(token);
    if (decoded === undefined) return undefined;

    let expired = undefined;
    if (decoded.exp !== undefined) {
      const expires = parseFloat(decoded.exp as unknown as string);
      if (!isNaN(expires)) expired = Date.now() / 1000 > expires;
    }
    if (typeof decoded.sub !== "string") return undefined;
    return { sub: decoded.sub, expired };
  } catch {
    return undefined;
  }
}

export function decodedValidSub(
  token: string,
  requireExpiry: boolean = true,
): string | undefined {
  try {
    const decoded = decodeToken(token);
    if (decoded === undefined) return undefined;
    if (requireExpiry && (decoded.expired === undefined || decoded.expired))
      return undefined;
    return decoded.sub;
  } catch {
    return undefined;
  }
}
